export default __webpack_public_path__ + "static/media/red-dot-single.8bafd888.svg";